"use client";import{jsxs as e,jsx as r}from"react/jsx-runtime";import{twMerge as t}from"tailwind-merge";import{forwardRef as o}from"react";import{Box as i}from"../../Base/Layouts/Box/Box.js";import"../../Base/Layouts/FullBleed/FullBleed.js";function a(e,r,t){return r in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e}function l(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{},o=Object.keys(t);"function"==typeof Object.getOwnPropertySymbols&&(o=o.concat(Object.getOwnPropertySymbols(t).filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})))),o.forEach((function(r){a(e,r,t[r])}))}return e}function n(e,r){if(null==e)return{};var t,o,i=function(e,r){if(null==e)return{};var t,o,i={},a=Object.keys(e);for(o=0;o<a.length;o++)t=a[o],r.indexOf(t)>=0||(i[t]=e[t]);return i}(e,r);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);for(o=0;o<a.length;o++)t=a[o],r.indexOf(t)>=0||Object.prototype.propertyIsEnumerable.call(e,t)&&(i[t]=e[t])}return i}const s=({isDisabled:e,isSelected:o=!1,isError:i,className:a})=>/*#__PURE__*/r("div",{className:t("relative box-border flex h-[18px] w-[18px] items-center justify-center rounded-full border p-[4px]",
// 체크되었고 비활성화 상태의 경우
o&&e?"bg-w-white border-primary-100 cursor-not-allowed":
// 비활성화 상태의 경우
e?"bg-w-gray-50 border-w-gray-200 cursor-not-allowed":
// 활성화 상태에서 체크되었고 오류가 없는 경우
o&&!i?"bg-w-white border-primary-500":
// 활성화 상태에서 체크되었고 오류가 있는 경우
o&&i?"bg-w-white border-w-red-500":
// 활성화 상태에서 체크되지 않았고 오류가 있는 경우
!o&&i?"border-w-red-500":"bg-white border-w-gray-200 group-hover:border-primary-500 cursor-pointer",a),role:"radio-button",children:/*#__PURE__*/r("div",{className:t("size-2 rounded-full bg-primary transition-all duration-100 ease-in-out",!o&&"h-0 w-0",i&&"bg-w-red-500",e&&"bg-w-gray-200",o&&e&&"bg-primary-100")})}),d=/*#__PURE__*/o(((t,o)=>{var{value:a="",isSelected:d=!1,isDisabled:c=!1,isError:u=!1,className:b}=t,m=n(t,["value","isSelected","isDisabled","isError","className"]);/*#__PURE__*/
return e(i,{"data-testid":"design-system-radio",className:"group cursor-pointer",children:[
/*#__PURE__*/r("input",l({ref:o,type:"radio",className:"hidden",value:a,checked:d,disabled:c},m)),
/*#__PURE__*/r(s,{isSelected:d,isError:u,isDisabled:c,className:b})]})}));
/**
 * 사용자가 여러 옵션 중 하나를 선택할 수 있는 라디오 버튼 컴포넌트입니다.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.value=''] - 라디오 버튼의 값
 * @param {boolean} [props.isSelected=false] - 라디오 버튼의 선택 상태
 * @param {boolean} [props.isDisabled=false] - 라디오 버튼의 비활성화 상태
 * @param {boolean} [props.isError=false] - 라디오 버튼의 에러 상태
 * @param {string} [props.className] - 추가적인 스타일링을 위한 클래스명
 *
 * @example
 * // 기본 사용
 * <Radio value="option1" />
 *
 * // 선택된 상태
 * <Radio value="option2" isSelected={true} />
 *
 * // 비활성화 상태
 * <Radio value="option3" isDisabled={true} />
 *
 * // 에러 상태
 * <Radio value="option4" isError={true} />
 *
 * // 커스텀 스타일
 * <Radio value="option5" className="custom-radio" />
 */d.displayName="Radio";export{d as Radio};
